import React, {Component} from 'react';
import autobind from 'autobind-decorator';

import {service as PermitTypeService} from "../../Services/PermitTypeService";

export class PermitTypeViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            permitTypes: [],
            permitType: null
        };
    }

    componentDidMount() {
        PermitTypeService.Get()
            .then((x) =>
                this.setState({
                    permitTypes: x.result
                }, () => {
                    let permitType = this.state.permitTypes.find((y) => y.permitTypeId == this.props.PermitTypeId);
                    if(permitType) {
                        this.setState({
                            permitType: permitType
                        });
                    }
                })
            );
    }

    componentDidUpdate(prevProps) {
        if(prevProps.PermitTypeId !== this.props.PermitTypeId) {
            const permitType = this.state.permitTypes.find((y) => y.permitTypeId == this.props.PermitTypeId);
            if(permitType) {
                this.setState({
                    permitType: permitType
                });
            } else {
                this.setState({
                    permitType: null
                });
            }
        }
    }

    @autobind
    getTitle() {
        const { permitType } = this.state;

        if(permitType) {
            return permitType.name;
        }
        return "";
    }

    @autobind
    getContextDescription() {
        const { permitType } = this.state;

        if(permitType) {
            return permitType.PermitOrganization.name;
        }
        return "";
    }

    render() {
        const title = this.getTitle();
        const context = this.getContextDescription();

        return <div className="sb-context-node-viewer">
            <div className="sb-context-node-link">{title}</div>
            <div className="sb-autocomplete-subtext">{context}</div>
        </div>;
    }
}


